/*
 * Keep mast size products on one PDP session by reusing the storefront's
 * section swap pipeline instead of following the native product links.
 */
(function () {
  'use strict';

  if (window.MastProductVariationSwap) return;

  document.addEventListener('click', async (event) => {
    const link = event.target.closest('.variant-picker a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const productSection = link.closest('.shopify-section');
    if (!productSection?.querySelector('[data-loftsails-product]')) return;

    const destination = new URL(link.href, window.location.origin);
    if (destination.origin !== window.location.origin || !destination.pathname.includes('/products/')) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const picker = link.closest('.variant-picker');
    const errorMessage = productSection.querySelector('[data-mast-variation-error]');
    if (picker?.dataset.mastSwapPending === 'true') return;
    if (picker) {
      picker.dataset.mastSwapPending = 'true';
      picker.setAttribute('aria-busy', 'true');
    }
    if (errorMessage) errorMessage.hidden = true;

    try {
      if (!window.LoftsailsProductSwap?.swap) throw new Error('Product swap is unavailable');
      await window.LoftsailsProductSwap.swap(destination.href, null);
    } catch (error) {
      if (error.name === 'AbortError') return;
      if (errorMessage) {
        errorMessage.hidden = false;
        errorMessage.classList.remove('visually-hidden');
        errorMessage.focus({ preventScroll: true });
      }
    } finally {
      if (picker) {
        delete picker.dataset.mastSwapPending;
        picker.removeAttribute('aria-busy');
      }
    }
  }, true);

  window.MastProductVariationSwap = true;
})();
